export const drawBorder = (
  ctx: CanvasRenderingContext2D,
  cssW: number,
  cssH: number
) => {
  ctx.save();
  ctx.lineWidth = 2;
  ctx.strokeStyle = "#ccc";
  ctx.strokeRect(0, 0, cssW, cssH);
  ctx.restore();
};
